import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { defaultTheme, withTheme } from 'common/styling/theme';

import { staticStyles, getDynamicStyles } from './style';

const PaymentErrors = ({ displayErrors, theme }) => {
  const categories = Object.entries(displayErrors || {}).filter(([, errors]) => Object.keys(errors).length > 0);
  const dynamicStyles = getDynamicStyles(theme);

  if (!categories.length) {
    return null;
  }

  return (
    <section className="PaymentErrors">
      <h3 className="PaymentErrors__title">
        <FormattedMessage id="justErrorDetails" />
      </h3>
      {categories.map(([category, errors]) => (
        <details className="PaymentErrors__category" key={category}>
          <summary className="PaymentErrors__summary">
            {category} ({Object.keys(errors).length})
          </summary>
          <ul className="PaymentErrors__list">
            {Object.entries(errors).map(([timestamp, message]) => (
              <li className="PaymentErrors__item" key={timestamp}>
                <time className="PaymentErrors__timestamp" dateTime={timestamp.replace(' ', 'T')}>
                  {timestamp}
                </time>
                <p className="PaymentErrors__message">{message}</p>
              </li>
            ))}
          </ul>
        </details>
      ))}
      <style jsx>{staticStyles}</style>
      <style jsx>{dynamicStyles}</style>
    </section>
  );
};

PaymentErrors.propTypes = {
  displayErrors: PropTypes.objectOf(PropTypes.objectOf(PropTypes.string)),
  theme: PropTypes.object,
};

PaymentErrors.defaultProps = {
  displayErrors: {},
  theme: defaultTheme,
};

export default withTheme()(PaymentErrors);
